import { COLORS } from '@styles/colors'
import { textSM } from '@styles/fonts'
import styled, { css } from 'styled-components'

export const AutoCompleteInput = styled.div`
  position: relative;

  ${({ isOpen }) =>
    isOpen &&
    css`
      input {
        border-bottom-color: transparent;
        border-radius: 4px 4px 0 0;
      }
    `}
`

export const GooglePlaceAutoCompleteResults = styled.div`
  border: 1px solid ${COLORS.grey[40]};
  border-top: none;
  border-radius: 0 0 4px 4px;
  position: absolute;
  width: 100%;
  top: calc(100% - 1px);
  background-color: ${COLORS.white};
  z-index: 9;
`

export const AutAutoCompleteItem = styled.div`
  color: ${COLORS.navi};
  transition: all 0.25s ease-in;
  padding: 10px 16px;
  cursor: pointer;

  &:hover {
    background-color: ${COLORS.secondary};
    color: ${COLORS.white};
  }
`

export const HelpText = styled.span`
  ${textSM};
  color: ${COLORS.grey[60]};
  display: flex;
  align-items: center;
  margin-top: 10px;
`
